<template>
    <ot-section v-bind="$attrs" :theme="$otTheme" section>
        <ot-alert color="info" round type="info" show-icon>
            <p slot="title">
                <ot-link color="info" target="_blank" href="//2o3t.github.io/2o3t-IconFont"><span>更多图标内容, 请查看字体图标库</span></ot-link>
            </p>
        </ot-alert>
    </ot-section>
</template>

<script>
export default {
    data() {
        return {
            code: decodeURIComponent(`%3Ctemplate%3E%0A%20%20%20%20%3Cot-section%20section%3E%0A%20%20%20%20%20%20%20%20%3Cot-alert%20color%3D%22info%22%20round%20type%3D%22info%22%20show-icon%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cp%20slot%3D%22title%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-link%20color%3D%22info%22%20target%3D%22_blank%22%20href%3D%22%2F%2F2o3t.github.io%2F2o3t-IconFont%22%3E%3Cspan%3E%E6%9B%B4%E5%A4%9A%E5%9B%BE%E6%A0%87%E5%86%85%E5%AE%B9%2C%20%E8%AF%B7%E6%9F%A5%E7%9C%8B%E5%AD%97%E4%BD%93%E5%9B%BE%E6%A0%87%E5%BA%93%3C%2Fspan%3E%3C%2Fot-link%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fp%3E%0A%20%20%20%20%20%20%20%20%3C%2Fot-alert%3E%0A%20%20%20%20%3C%2Fot-section%3E%0A%3C%2Ftemplate%3E%0A%0A%3Cscript%3E%0Aexport%20default%20%7B%0A%20%20%20%20data()%20%7B%0A%20%20%20%20%20%20%20%20return%20%7B%0A%20%20%20%20%20%20%20%20%7D%3B%0A%20%20%20%20%7D%2C%0A%7D%3B%0A%3C%2Fscript%3E`),
        };
    },
};
</script>

